import * as React from 'react';

/*type Props = {}*/
type Props = any; // eslint-disable-line

type State = {
  containerWidth: number;
  leftBound: number;
};

// This is really weirdly done need to fix it up.
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const responsive = (
  // eslint-disable-next-line
  WrappedComponent: React.ComponentType<any>
) =>
  class ResponsiveWrapper extends React.Component<Props, State> {
    chartContainer: Element | null = null;

    constructor() {
      super(WrappedComponent);
      this.state = {
        containerWidth: 0,
        leftBound: 0,
      };
    }

    fitParentContainer = () => {
      const { containerWidth } = this.state;
      if (this.chartContainer) {
        const currentContainerWidth = this.chartContainer.getBoundingClientRect().width;
        const yAxisLeft = document.querySelector('.axis-left');
        const currentLeftBound = yAxisLeft?.getBoundingClientRect().right ?? 0;

        const shouldResize = containerWidth !== currentContainerWidth;


        if (shouldResize) {
          this.setState({
            containerWidth: currentContainerWidth,
            leftBound: currentLeftBound,
          });
        }
      }
    };

    componentDidMount = () => {
      this.fitParentContainer();
      window.addEventListener('resize', this.fitParentContainer);
    };

    componentWillUnmount = () => {
      window.removeEventListener('resize', this.fitParentContainer);
    };

    renderChart = () => {
      const { containerWidth, leftBound } = this.state;
      return (
        <WrappedComponent {...this.props} parentWidth={containerWidth} leftBound={leftBound} />
      );
    };

    render() {
      const { containerWidth } = this.state;
      const shouldRenderChart = containerWidth !== null;

      return (
        <div
          ref={el => {
            if (el) this.chartContainer = el;
          }}
          className="responsive-wrapper"
        >
          {shouldRenderChart && this.renderChart()}
        </div>
      );
    }
  };

export default responsive;
